import * as tslib_1 from "tslib";
import * as _ from 'lodash';
import { FormatCurrencyPipe } from 'src/app/shared/common/pipes/format-currency.pipe';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { Translations } from 'src/app/shared/utils/translations';
var PaymentTemplate = /** @class */ (function () {
    function PaymentTemplate() {
        var _a = InjectorService.get().get(ConfigService), _b = _a.booking, creditCard = _b.creditCard, _c = _b.resume, payments = _c.payments, currency = _c.currency, currencyBuyer = _c.currencyBuyer, paymentConfig = _c.paymentConfig, bk = _b.bk, project = _a.project, rest = tslib_1.__rest(_a, ["booking", "project"]);
        var _payments = (_.get(payments, 'paymentsDetail', [])).concat((_.get(payments, 'deposit', [])));
        Object.assign(this, {
            _creditCard: creditCard,
            _currency: currency,
            _currencyBuyer: currencyBuyer,
            _config: _.get(rest[project], 'config.config'),
            _payments: _payments,
            _payment: _payments.find(function (p) { return p.selected; }),
            _bk: bk,
            _mcp: paymentConfig.mcp
        });
        this.getTranslations();
    }
    Object.defineProperty(PaymentTemplate.prototype, "creditCard", {
        get: function () {
            return this._creditCard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "payment", {
        get: function () {
            return this._payment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "payments", {
        get: function () {
            return this._payments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "bk", {
        get: function () {
            return this._bk;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "currency", {
        get: function () {
            return this._currency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTemplate.prototype, "currencyBuyer", {
        get: function () {
            return this._currencyBuyer;
        },
        enumerable: true,
        configurable: true
    });
    PaymentTemplate.prototype.getAmountTranslation = function () {
        var _a = this._getPayment(), amount = _a.amount, currency = _a.currency;
        return "" + InjectorService.get().get(FormatCurrencyPipe).transform(amount, currency);
    };
    PaymentTemplate.prototype._getPayment = function () {
        if (this._mcp.enabled) {
            return {
                amount: this.payment.mcp.amount,
                currency: this.payment.mcp.currency
            };
        }
        return {
            amount: this.payment.amount,
            currency: this.payment.currency
        };
    };
    PaymentTemplate.prototype.getTranslations = function () {
        var _this = this;
        new Translations([
            'payment-error-title',
            'payment-success-title',
            'payment-success-description',
            'payment-new-charge',
            'payment-add-card',
            'payment-add-card-description',
            'payment-new-charge-amount',
            'payment-new-charge-amount-portal',
            'payment-new-charge-detail',
            'payment-new-charge-change-card',
            'purchase-credit-card-error-description',
            'purchase-credit-card-error-description-portal',
            'payment-new-charge-amount-ideal',
            'payment-new-charge-amount-sofort',
            'purchase-ideal-error-description',
            'purchase-ideal-error-description-portal',
            'purchase-sofort-error-description',
            'purchase-sofort-error-description-portal',
            'detailed-payment-success-title',
            'detailed-payment-success-description',
            'deposit-payment',
            'deposit',
            'payment.one',
            'payment-new-charge-amount-redirect',
            'payment-new-charge-redirect',
            'purchase-redirect-error-description',
            'purchase-redirect-error-description-portal',
            'payment.one',
            'payment-new-charge-deposit',
            'detailed-deposit-success-description',
            'card-hold'
        ]).get(function (translations) {
            _this._translations = translations;
            _this.onTranslations(translations);
        });
    };
    PaymentTemplate.prototype.refreshTranslations = function () {
        this.onTranslations(this._translations);
    };
    PaymentTemplate.prototype.onTranslations = function (translations) {
        throw new Error('onTranslations must be implemented');
    };
    return PaymentTemplate;
}());
export { PaymentTemplate };
